import React from 'react';

/**
 * WaveDivider - Flowing watercolor wave pattern section divider
 * Based on Real Patients brand deck (pages 13, 15)
 */
export const WaveDivider = ({
  flip = false,
  height = 80,
  className = ''
}) => {
  return (
    <div
      style={{
        width: '100%',
        height: `${height}px`,
        overflow: 'hidden',
        position: 'relative',
        transform: flip ? 'scaleY(-1)' : 'none',
        marginTop: flip ? '-1px' : '0',
        marginBottom: flip ? '0' : '-1px'
      }}
      className={className}
    >
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        style={{
          width: '100%',
          height: '100%',
          display: 'block'
        }}
      >
        <defs>
          {/* Gradient definitions for brand colors */}
          <linearGradient id="waveGradient1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#EBA09B" stopOpacity="0.6" />
            <stop offset="25%" stopColor="#F5B9A5" stopOpacity="0.5" />
            <stop offset="50%" stopColor="#F5D7AA" stopOpacity="0.4" />
            <stop offset="75%" stopColor="#B5C9A8" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#A8C5C5" stopOpacity="0.4" />
          </linearGradient>
          <linearGradient id="waveGradient2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#F5B9A5" stopOpacity="0.4" />
            <stop offset="30%" stopColor="#F5D7AA" stopOpacity="0.35" />
            <stop offset="60%" stopColor="#E8B4B8" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#A8C5C5" stopOpacity="0.35" />
          </linearGradient>
          <linearGradient id="waveGradient3" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#EBA09B" stopOpacity="0.3" />
            <stop offset="40%" stopColor="#F5D7AA" stopOpacity="0.25" />
            <stop offset="70%" stopColor="#B5C9A8" stopOpacity="0.2" />
            <stop offset="100%" stopColor="#A8C5C5" stopOpacity="0.25" />
          </linearGradient>
        </defs>

        {/* Back wave - most transparent */}
        <path
          d="M0,80 C200,40 400,100 600,60 C800,20 1000,80 1200,50 C1350,30 1400,60 1440,40 L1440,120 L0,120 Z"
          fill="url(#waveGradient3)"
        />

        {/* Middle wave */}
        <path
          d="M0,70 C180,100 360,50 540,80 C720,110 900,40 1080,70 C1260,100 1380,50 1440,60 L1440,120 L0,120 Z"
          fill="url(#waveGradient2)"
        />

        {/* Front wave - most visible */}
        <path
          d="M0,90 C240,60 480,110 720,80 C960,50 1200,100 1440,70 L1440,120 L0,120 Z"
          fill="url(#waveGradient1)"
        />
      </svg>
    </div>
  );
};

export default WaveDivider;
